// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"9c9b4fe8","787":"d67a358d"}[chunkId] + ".chunk.js";
};